var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04027 0.946045C3.02525 0.946045 0.597565 3.34179 0.597565 6.31714V24.9905C0.597565 27.9658 3.02525 30.3616 6.04027 30.3616H16.296V18.8619H13.2146V14.7217H16.296V11.1845C16.296 8.40546 18.1166 5.85384 22.3106 5.85384C24.0087 5.85384 25.2644 6.01472 25.2644 6.01472L25.1656 9.88103C25.1656 9.88103 23.885 9.86909 22.4876 9.86909C20.9752 9.86909 20.7327 10.5568 20.7327 11.6984V14.7217H25.2858L25.0874 18.862H20.7327V30.3616H24.9626C27.9776 30.3616 30.4053 27.9658 30.4053 24.9905V6.31717C30.4053 3.34182 27.9776 0.946074 24.9626 0.946074L6.04027 0.946045Z",
    fill: "#33448A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon-fb.9b60837273faf9fbdb044580e966e147.svg";
export { ForwardRef as ReactComponent };